import React, { useState } from 'react';

import {
  Text,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Button,
  MenuDivider,
  MenuGroup,
} from '@chakra-ui/react';
import { MdExpandMore, MdLanguage } from 'react-icons/md';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import jwtDecode, { JwtPayload } from 'jwt-decode';
import logo from '~/assets/images/elgin.png';
import { colors } from '~/styles/colors';
import { ApplicationState } from '~/store/store';
import { useI18n } from '~/i18n';
import { Container, Content, Profile, StyledBurger } from './Header_Styles';
import RightNav from './RightNav';

export default function Header() {
  const [open, setOpen] = useState(false);
  const { accessToken } = useSelector((state: ApplicationState) => state.auth);
  const decodedToken: any = jwtDecode<JwtPayload>(accessToken);
  const { email, username } = decodedToken;
  const userInfo = email || username || '';
  const { language, setLanguage, t } = useI18n();

  return (
    <Container>
      <Content>
        <img src={logo} alt={t('Logo Elgin')} />
        <StyledBurger open={open} onClick={() => setOpen(!open)}>
          <div />
          <div />
          <div />
        </StyledBurger>

        <RightNav open={open} userInfo={userInfo} />

        <aside>
          <Profile>
            <div data-no-translate="true">
              <Menu autoSelect={false} strategy="fixed">
                <MenuButton
                  as={Button}
                  className="menu__btn"
                  variant="ghost"
                  leftIcon={<MdLanguage size={18} color={colors.gray200} />}
                  rightIcon={<MdExpandMore size={18} color={colors.gray200} />}
                >
                  <Text fontSize={14} fontWeight={500} color={colors.gray200}>
                    {language}
                  </Text>
                </MenuButton>
                <MenuList className="menu__list">
                  <MenuGroup title={t('Idioma')} className="menu__group__title">
                    <MenuDivider />
                    <MenuItem className="menu__item" maxW="200px" onClick={() => setLanguage('pt-BR')}>
                      <Text fontSize={14} fontWeight={500} color={colors.gray200}>
                        Português
                      </Text>
                    </MenuItem>
                    <MenuItem className="menu__item" maxW="200px" onClick={() => setLanguage('en')}>
                      <Text fontSize={14} fontWeight={500} color={colors.gray200}>
                        English
                      </Text>
                    </MenuItem>
                    <MenuItem className="menu__item" maxW="200px" onClick={() => setLanguage('es')}>
                      <Text fontSize={14} fontWeight={500} color={colors.gray200}>
                        Español
                      </Text>
                    </MenuItem>
                  </MenuGroup>
                </MenuList>
              </Menu>
            </div>
            <div data-no-translate="true">
              <Menu autoSelect={false} strategy="fixed">
                <MenuButton
                  as={Button}
                  className="menu__btn"
                  variant="ghost"
                  rightIcon={<MdExpandMore size={18} color={colors.gray200} />}
                >
                  <Avatar size="sm" bg={colors.primary} />
                </MenuButton>
                <MenuList className="menu__list">
                  <MenuGroup title={userInfo} className="menu__group__title">
                    <MenuDivider />
                    <Link to={{ pathname: '/logout', state: { isLogin: false } }}>
                      <MenuItem className="menu__item" maxW="200px">
                        <Text fontSize={14} fontWeight={500} color={colors.gray200}>
                          {t('Sair')}
                        </Text>
                      </MenuItem>
                    </Link>
                  </MenuGroup>
                </MenuList>
              </Menu>
            </div>
          </Profile>
        </aside>
      </Content>
    </Container>
  );
}
